import { api } from './client'

export type EpicStatus = 'planned' | 'in_progress' | 'done' | 'cancelled'

export type Epic = {
  id: number
  project_id: number
  name: string
  description: string | null
  color: string | null
  status: EpicStatus
  start_date: string | null
  due_date: string | null
  sort_order: number
  /** Present on list responses only; null from show/create/update. */
  story_count: number | null
  done_count: number | null
  created_at: string
  updated_at: string
}

/** GET /v1/epics — returns a bare array (not paginated). project_id is required. */
export async function listEpics(projectId: number): Promise<Epic[]> {
  return api<Epic[]>('/epics', { query: { project_id: projectId } })
}

export type EpicCreate = {
  project_id: number
  name: string
  description?: string
  color?: string
  status?: EpicStatus
  start_date?: string
  due_date?: string
}

export async function createEpic(data: EpicCreate): Promise<Epic> {
  return api<Epic>('/epics', { method: 'POST', body: data })
}

/** A sent-but-empty description, color or date clears it. */
export type EpicUpdate = Partial<Omit<EpicCreate, 'project_id'>> & { sort_order?: number }

export async function updateEpic(id: number, patch: EpicUpdate): Promise<Epic> {
  return api<Epic>(`/epics/${id}`, { method: 'PATCH', body: patch })
}

export async function deleteEpic(id: number): Promise<void> {
  return api<void>(`/epics/${id}`, { method: 'DELETE' })
}
